import React from 'react';
import { Modal, Input, Form, Select } from 'antd';

class CorreoModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.form.resetFields();
        this.props.onClose();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    correoCliente: values.correoCliente
                }
                
                this.props.onSend(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={"Enviar Correo"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"EnviarCorreo"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                destroyOnClose={true}
                style={{ top: 30 }}
                width={800}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Correo">
                                {getFieldDecorator('correoCliente', {
                                    initialValue: this.props.formValues.correoCliente,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Correo"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
 {/*                    <div className="row">
                        <div className="col-md-12 form-group">
                            <embed
                                src={this.props.formValues.file+ '#view=fitH'}
                                style={{ width: '100%', height: 600 }}
                                type="application/pdf"
                            />
                        </div>
                    </div> */}
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(CorreoModal)